import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { TemplateKind } from 'src/app/enums/templateKind.enum';
import { AuthService } from 'src/app/services/auth.service';
import { PermissionService } from 'src/app/services/permission.service';
import { TEMPLATE_KIND_QUERY_PARAM } from 'src/app/shared/constants/templateKind.constants';
import { canUseSurveyTemplates, resolveTemplateKind } from 'src/app/shared/helpers/template-kind.helper';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

interface TemplateKindOption {
  value: TemplateKind;
  label: string;
}

@Component({
  standalone: false,
  selector: 'app-template-kind-toggle',
  templateUrl: './template-kind-toggle.component.html',
  styleUrls: ['./template-kind-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateKindToggleComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly permissionService = inject(PermissionService);

  readonly isAllowed = canUseSurveyTemplates(this.authService, this.permissionService);
  readonly options: TemplateKindOption[] = [
    { value: TemplateKind.Sample, label: 'Sample' },
    { value: TemplateKind.Survey, label: 'Survey' }
  ];
  readonly activeKind$: Observable<TemplateKind> = this.route.queryParamMap.pipe(
    map(params => resolveTemplateKind(params.get(TEMPLATE_KIND_QUERY_PARAM), this.isAllowed)),
    distinctUntilChanged()
  );
  readonly trackByIndex = trackByIndex;

  select(kind: TemplateKind): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { [TEMPLATE_KIND_QUERY_PARAM]: kind === TemplateKind.Sample ? null : kind },
      queryParamsHandling: 'merge'
    });
  }
}
